export const ISSUE_LIST = {
  SET: 'SET_ISSUE_LIST',
  ADD: 'ADD_ISSUE_LIST',
  RESET: 'RESET_ISSUE_LIST',
} as const;

export const STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const;

export const PATH = {
  MAIN: '/',
  ISSUES: '/issues',
  ISSUEDETAIL: '/issues/:issueNumber',
  ERROR: '/*',
} as const;

export const ERROR_MESSAGE = {
  USER: {
    404: '요청받은 페이지를 찾을 수 없습니다.',
    422: '잘못된 요청 형식으로 서버에서 해당 작업을 수행할 수 없습니다.',
    DEFAULT:
      '서버 오류가 발생했습니다. 해당 오류가 지속적으로 발생한다면 관리자에게 문의해주세요\n 참고: https://docs.github.com/ko/rest/issues/issues?apiVersion=2022-11-28',
  },
  DEV: {
    404: 'Github API 에러메시지: Resource not found\n 참고: https://docs.github.com/ko/rest/issues/issues?apiVersion=2022-11-28',
    422: 'Github API 에러메시지: Validation failed, or the endpoint has been spammed.\n 참고: https://docs.github.com/ko/rest/issues/issues?apiVersion=2022-11-28',
    DEFAULT:
      '서버 오류가 발생했습니다. 해당 오류가 지속적으로 발생한다면 관리자에게 문의해주세요.\n 참고: https://docs.github.com/ko/rest/issues/issues?apiVersion=2022-11-28',
  },
} as const;

export const AD = {
  URL: 'https://www.wanted.co.kr/',
  IMG: 'https://image.wanted.co.kr/optimize?src=https%3A%2F%2Fstatic.wanted.co.kr%2Fimages%2Fuserweb%2Flogo_wanted_black.png&w=110&q=100',
} as const;
